import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TargetingPreferencesService } from '../../../Common/TargetingShared/services/targeting-preferences.service';

/** @TODO - this route gaurd is questionable */
@Injectable()
export class InfluencerStreamsActivateGuard implements CanActivate {

    constructor(
        private targetingPreferencesService: TargetingPreferencesService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.targetingPreferencesService.targetingPreferences$.pipe(
            // Waits til info is fetched from backend
            filter(x => x !== null),
            map(prefs => {
                // TODO : redirect somewhere other than /
                return prefs.hasInfluencerStreams;
            })
        );
    }
}
